import undefsafe from 'undefsafe'
import querystring from 'query-string'

import { logError } from '../utils/errors'
import getProxyApiUrl from '../utils/getProxyApiUrl'
import axiosVerbose from '../utils/axios/axiosVerbose'

const fetchLandingPageContent = (parsedUrl, opts) => {
  return (dispatch, getState) => {
    const apiUrlPrefix = getProxyApiUrl(opts)
    const site = undefsafe(getState(), 'common.currentSite') || 'themeforest'
    const queryString = querystring.stringify({site, path: parsedUrl.path})

    return axiosVerbose.get(`${apiUrlPrefix}/shopfront_api/landing_page?${queryString}`)
      .then(res => dispatch(fetchLandingPageContentSuccess(res.data)))
      .catch(logError)
  }
}

const fetchLandingPageContentSuccess = (content) => {
  return {
    type: 'fetchLandingPageContentSuccess',
    payload: content
  }
}

export default fetchLandingPageContent



// WEBPACK FOOTER //
// ./common/actions/fetchLandingPageContent.js